import React from 'react';
import './CurvedBottom.css';

const curvedBottom = ( props ) => (
	<div className="CurvedBottomContainer">
		<svg className="CurvedBottom" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" preserveAspectRatio="none">
			<path d="M0 0 C 50 100 50 100 100 0 V100 100 H0 0 Z" />
		</svg>
	</div>
);

export default curvedBottom;



// WEBPACK FOOTER //
// ./src/components/CurvedBottom/CurvedBottom.js